// ============================================================================
// Block Layout — Constants & Token Maps (Block-level layout controls)
// ============================================================================

import type { DirectionalSpacing } from '../types';

export const BLOCK_PADDING_VALUES: Record<string, string> = {
  none: '0',
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  '2xl': '48px',
  '3xl': '64px',
  '4xl': '80px',
  '5xl': '96px',
  '6xl': '120px',
};

export const BLOCK_BORDER_RADIUS: Record<string, string> = {
  none: '0',
  sm: '4px',
  md: '8px',
  lg: '16px',
  full: '9999px',
};

export const BLOCK_MAX_WIDTH: Record<string, string> = {
  auto: '100%',
  '400px': '400px',
  '600px': '600px',
  '800px': '800px',
  '1000px': '1000px',
};

export const BLOCK_ALIGNMENT_CSS: Record<string, string> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

/**
 * Resolve a spacing value (uniform token string or directional object) to a CSS string.
 * Returns undefined for 'none' or undefined input.
 */
export function resolveSpacingToCSS(
  value: string | DirectionalSpacing | undefined,
): string | undefined {
  if (!value || value === 'none') return undefined;
  if (typeof value === 'string') return BLOCK_PADDING_VALUES[value] ?? undefined;
  // Directional object
  const top = BLOCK_PADDING_VALUES[value.top ?? 'none'] ?? '0';
  const right = BLOCK_PADDING_VALUES[value.right ?? 'none'] ?? '0';
  const bottom = BLOCK_PADDING_VALUES[value.bottom ?? 'none'] ?? '0';
  const left = BLOCK_PADDING_VALUES[value.left ?? 'none'] ?? '0';
  return `${top} ${right} ${bottom} ${left}`;
}
